import { createSelector } from 'reselect';
import InternalRepatriationsTransactionsColumns from '../../containers/InternalRepatriationsTransactionsColumns';
import TableDefinitions from '../../../../../../common/TableDefinitions';
import CenterInitiatedRepatriationsTransactionsColumns from '../../containers/CenterInitiatedRepatriationsTransactionsColumns';

export const getIsLoading = (state) => state.listing.INTERNAL_REPATRIATIONS_TRANSACTIONS.isLoading;
export const getData = TableDefinitions.INTERNAL_REPATRIATIONS_TRANSACTIONS.getDataFunction();
export const getColumns = createSelector(getData, InternalRepatriationsTransactionsColumns);

export const getCroIsLoading = (state) => state.listing.CENTER_INITIATED_REPATRIATIONS.isLoading;
export const getCroData = TableDefinitions.CENTER_INITIATED_REPATRIATIONS.getDataFunction();
export const getCroColumns = createSelector(getCroData, CenterInitiatedRepatriationsTransactionsColumns);
